// Coordinates refer to the aligned 1652 x 925 ground plane, not screen pixels.
// WALK_AREAS are the gray roads plus the plaza pavement around the fountain;
// NO_GO subtracts solid obstacles (fountain complex, notice board, beds, benches).
export const WALK_AREAS = [
  [[584,488],[624,440],[681,402],[736,384],[919,383],[987,404],[1038,441],[1065,481],[1060,534],[1020,575],[966,611],[880,633],[770,626],[690,603],[629,569],[591,532]],
  [[433,478],[474,466],[532,464],[591,474],[625,523],[568,563],[515,565],[477,532]],
  [[288,564],[447,531],[497,560],[568,578],[580,603],[545,634],[522,621],[478,582],[438,557],[301,585]],
  [[1030,402],[1060,320],[1056,239],[1098,225],[1126,286],[1119,342],[1082,404],[1066,453],[1090,480],[1063,492],[1034,460]],
  [[1044,535],[1098,529],[1169,536],[1230,518],[1282,497],[1318,498],[1374,541],[1370,564],[1312,536],[1271,526],[1214,546],[1169,565],[1098,553],[1037,565]],
  [[911,605],[946,596],[977,647],[1013,687],[1000,711],[965,682],[939,642]],
  [[354,201],[391,219],[444,250],[503,275],[530,270],[550,295],[507,335],[478,385],[442,419],[413,454],[361,494],[307,516],[225,538],[163,555],[125,583],[93,612],[94,637],[64,632],[49,617],[61,592],[99,558],[165,528],[260,502],[329,473],[372,435],[398,405],[435,390],[461,347],[481,306],[458,281],[399,251],[353,226]],
  [[467,355],[485,321],[526,272],[566,232],[591,196],[597,165],[630,167],[622,206],[597,244],[570,286],[541,326],[524,370],[496,398],[475,408]],
  [[511,385],[552,358],[592,340],[606,369],[603,402],[555,426],[537,467],[511,479]],
  [[1425,303],[1470,278],[1511,255],[1538,266],[1499,296],[1450,322]],
  [[1363,458],[1412,432],[1455,411],[1510,388],[1567,365],[1596,368],[1570,396],[1519,419],[1476,441],[1423,469],[1384,496],[1320,516],[1283,518],[1270,497],[1320,482]],
  [[1378,532],[1440,553],[1510,586],[1579,620],[1626,652],[1629,674],[1595,689],[1555,638],[1483,604],[1419,580],[1370,557]],
  [[1569,660],[1602,676],[1550,709],[1489,746],[1410,780],[1327,822],[1260,858],[1165,881],[1062,889],[998,880],[973,849],[958,797],[948,742],[933,694],[920,650],[900,624],[933,601],[958,640],[976,679],[991,730],[1006,782],[1016,834],[1037,855],[1132,856],[1239,833],[1311,797],[1396,753],[1470,721],[1529,687]],  [[379,766],[410,741],[447,704],[477,668],[516,626],[537,596],[567,596],[568,629],[540,661],[503,701],[467,742],[431,777],[398,807],[359,842],[343,875],[318,873],[326,841],[348,805]],
  [[325,866],[382,876],[439,882],[500,885],[582,894],[659,905],[727,910],[809,907],[886,890],[953,865],[984,849],[1022,873],[976,899],[916,916],[836,924],[683,924],[577,918],[493,906],[430,903],[375,902],[320,895]],
  [[1414,352],[1444,326],[1494,304],[1524,340],[1518,392],[1470,416],[1428,394]],
  // Open pavement north-west of the notice board, joining the mountain road
  // descent to the plaza ring and the board-side lane.
  [[430,414],[474,398],[520,394],[548,410],[544,470],[500,472],[462,470],[432,452]],
  // Bridges: thin physical road surfaces between authored polygons. Kept as
  // separate bands so the road loops stay hand-editable.
  [[478,394],[496,376],[516,362],[544,352],[570,342],[594,334],[612,356],[608,384],[588,394],[564,388],[540,392],[518,398],[498,406],[482,412],[474,404]],
  [[1436,318],[1462,298],[1492,294],[1504,310],[1484,330],[1454,340],[1434,334]],
];
export const NO_GO = [
  [[1101,487],[1164,477],[1206,521],[1169,540],[1100,532]],
  [[1200,437],[1294,407],[1357,443],[1280,481],[1197,458]],
  // Fountain complex: pool, planted ring and the standing stone are one solid obstacle.
  [[719,500],[727,458],[748,432],[775,415],[790,392],[800,388],[858,388],[868,394],[878,416],[898,436],[917,460],[926,502],[919,545],[896,572],[862,586],[822,590],[780,586],[748,572],[727,545]],
  // Benches south-east of the fountain.
  [[946,580],[950,556],[1010,551],[1014,575]],
  // Notice board: only its physical ground base blocks; the road passes behind it.
  [[446,402],[516,398],[520,492],[452,496]],
];
export const NOTICE = [524,484];
const distance=(a,b)=>Math.hypot(a[0]-b[0],a[1]-b[1]);
function contains([x,y],polygon){
  let inside=false;
  for(let i=0,j=polygon.length-1;i<polygon.length;j=i++){
    const [ax,ay]=polygon[i],[bx,by]=polygon[j];
    if((ay>y)!==(by>y)&&x<(bx-ax)*(y-ay)/(by-ay)+ax)inside=!inside;
  }
  return inside;
}
export function isGround(x,y){
  return WALK_AREAS.some(p=>contains([x,y],p))&&!NO_GO.some(p=>contains([x,y],p));
}
// The validated walk mesh: polygon ground rasterized with clearance, then
// morphologically closed so hairline seams between neighbouring polygons
// (1-20px, hand-authored) become solid road, and finally obstacles subtracted.
// isNavigable reads this mesh, so planning, the crowd and the verify scripts
// all share one ground truth.
const CELL=6, COLS=Math.ceil(1652/CELL), ROWS=Math.ceil(925/CELL);
let MESH=null;
function buildMesh(){
  const boxes=WALK_AREAS.map(p=>[Math.min(...p.map(q=>q[0])),Math.min(...p.map(q=>q[1])),Math.max(...p.map(q=>q[0])),Math.max(...p.map(q=>q[1]))]);
  const inside=(x,y,i)=>{
    const b=boxes[i];
    if(x<b[0]||x>b[2]||y<b[1]||y>b[3])return false;
    const p=WALK_AREAS[i];
    let ins=false;
    for(let k=0,j=p.length-1;k<p.length;j=k++){
      const [ax,ay]=p[k],[bx,by]=p[j];
      if((ay>y)!==(by>y)&&x<(bx-ax)*(y-ay)/(by-ay)+ax)ins=!ins;
    }
    return ins;
  };
  const raw=new Uint8Array(COLS*ROWS);
  const noGoGrid=new Uint8Array(COLS*ROWS);
  for(let cy=0;cy<ROWS;cy++)for(let cx=0;cx<COLS;cx++){
    const x=cx*CELL,y=cy*CELL;
    if(NO_GO.some(p=>contains([x,y],p)))noGoGrid[cy*COLS+cx]=1;
  }
  for(let cy=0;cy<ROWS;cy++)for(let cx=0;cx<COLS;cx++){
    const x=cx*CELL,y=cy*CELL;
    let ok=!noGoGrid[cy*COLS+cx]&&inside(x,y,0);
    for(let i=1;i<WALK_AREAS.length&&!ok;i++)ok=inside(x,y,i);
    if(ok)for(let k=0;k<8&&ok;k++){
      const a=k*Math.PI/4,px=x+Math.cos(a)*3,py=y+Math.sin(a)*3;
      let g=inside(px,py,0);
      for(let i=1;i<WALK_AREAS.length&&!g;i++)g=inside(px,py,i);
      ok=g;
    }
    if(ok)raw[cy*COLS+cx]=1;
  }
  // Binary closing (Chebyshev disk r=2 cells): fills seams narrower than ~24px,
  // keeps straight road edges and convex corners exactly where they were.
  const R=2,dil=new Uint8Array(raw.length);
  for(let cy=0;cy<ROWS;cy++)for(let cx=0;cx<COLS;cx++){
    if(!raw[cy*COLS+cx])continue;
    for(let dy=-R;dy<=R;dy++)for(let dx=-R;dx<=R;dx++){
      const nx=cx+dx,ny=cy+dy;
      if(nx>=0&&ny>=0&&nx<COLS&&ny<ROWS)dil[ny*COLS+nx]=1;
    }
  }
  const closed=new Uint8Array(raw.length);
  for(let cy=0;cy<ROWS;cy++)for(let cx=0;cx<COLS;cx++){
    let all=1;
    for(let dy=-R;dy<=R&&all;dy++)for(let dx=-R;dx<=R;dx++){
      const nx=cx+dx,ny=cy+dy;
      if(nx<0||ny<0||nx>=COLS||ny>=ROWS||!dil[ny*COLS+nx]){all=0;break;}
    }
    closed[cy*COLS+cx]=all;
  }
  // Obstacles are subtracted after closing so seams cannot bleed through them,
  // dilated one cell first so sub-pixel slivers between obstacle and road
  // polygons cannot survive the closing either.
  const R1=1;
  for(let cy=0;cy<ROWS;cy++)for(let cx=0;cx<COLS;cx++){
    if(!closed[cy*COLS+cx])continue;
    let blocked=false;
    for(let dy=-R1;dy<=R1&&!blocked;dy++)for(let dx=-R1;dx<=R1;dx++){
      const nx=cx+dx,ny=cy+dy;
      if(nx<0||ny<0||nx>=COLS||ny>=ROWS)continue;
      if(noGoGrid[ny*COLS+nx]){blocked=true;break;}
    }
    if(blocked)closed[cy*COLS+cx]=0;
  }
  return closed;
}
function mesh(){
  if(!MESH)MESH=buildMesh();
  return MESH;
}
export function isNavigable(x,y){
  const cx=Math.round(x/CELL),cy=Math.round(y/CELL);
  if(cx<0||cy<0||cx>=COLS||cy>=ROWS)return false;
  return mesh()[cy*COLS+cx]===1;
}
export function clearSegment(a,b){
  const steps=Math.max(1,Math.ceil(distance(a,b)/2));
  for(let i=0;i<=steps;i++)if(!isNavigable(a[0]+(b[0]-a[0])*i/steps,a[1]+(b[1]-a[1])*i/steps))return false;
  return true;
}
export function seededRandom(seed){
  return ()=>{seed|=0;seed=seed+0x6D2B79F5|0;let t=Math.imul(seed^seed>>>15,1|seed);t=t+Math.imul(t^t>>>7,61|t)^t;return ((t^t>>>14)>>>0)/4294967296;};
}

// Grid navigation over the validated ground polygons. Cell chains come from a
// flood fill; string-pulling plus corner rounding then shorten the path, and
// every resulting edge is re-validated by clearSegment, so a planned path never
// leaves the roads or crosses buildings, the fountain or the beds.
export function createNavigation(){
  const walk=mesh().slice();
  const centerOf=i=>[(i%COLS)*CELL,((i/COLS)|0)*CELL];
  const cellOf=p=>{
    const x0=Math.min(COLS-1,Math.max(0,Math.round(p[0]/CELL))),y0=Math.min(ROWS-1,Math.max(0,Math.round(p[1]/CELL)));
    if(walk[y0*COLS+x0])return y0*COLS+x0;
    for(let r=1;r<=12;r++)for(let dy=-r;dy<=r;dy++)for(let dx=-r;dx<=r;dx++){
      if(Math.max(Math.abs(dx),Math.abs(dy))!==r)continue;
      const x=x0+dx,y=y0+dy;if(x<0||y<0||x>=COLS||y>=ROWS)continue;
      const i=y*COLS+x;if(walk[i])return i;
    }
    return -1;
  };
  const reachable=[];
  {
    const origin=cellOf(NOTICE),seen=new Uint8Array(COLS*ROWS),queue=[origin];seen[origin]=1;
    for(let head=0;head<queue.length;head++){
      const c=queue[head];reachable.push(centerOf(c));
      for(const d of [1,-1,COLS,-COLS]){
        const n=c+d;
        if(d===1&&n%COLS===0)continue;if(d===-1&&c%COLS===0)continue;
        if(n<0||n>=walk.length||!walk[n]||seen[n])continue;
        seen[n]=1;queue.push(n);
      }
    }
  }
  function path(a,b){
    const s=cellOf(a),g=cellOf(b);
    if(s<0||g<0)return null;
    const parent=new Map();parent.set(s,-1);
    let found=s===g;const queue=[s];
    for(let head=0;head<queue.length&&!found;head++){
      const cur=queue[head];
      for(const d of [1,-1,COLS,-COLS]){
        const n=cur+d;
        if(d===1&&n%COLS===0)continue;if(d===-1&&cur%COLS===0)continue;
        if(n<0||n>=walk.length||!walk[n]||parent.has(n))continue;
        parent.set(n,cur);
        if(n===g){found=true;break;}
        queue.push(n);
      }
    }
    if(!found)return null;
    const chain=[];
    for(let c=g;c>=0;c=parent.get(c))chain.push(centerOf(c));
    chain.reverse();
    // String-pull the raw cell chain, then round corners; every accepted edge
    // is clearSegment-validated, so shortcuts cannot leave the walkable ground.
    const pulled=[a];let i=0;
    while(i<chain.length-1){
      let j=chain.length-1;
      while(j>i+1&&!clearSegment(pulled[pulled.length-1],chain[j]))j--;
      pulled.push(chain[j]);i=j;
    }
    pulled.push(b);
    if(pulled.slice(1).some((p,k)=>!clearSegment(pulled[k],p)))return null;
    const smooth=[pulled[0]];
    for(let k=1;k<pulled.length-1;k++){
      const q=pulled[k-1],p=pulled[k],r=pulled[k+1];
      const inset=t=>{const d=Math.max(distance(t,p),.001),f=Math.min(9,d/4)/d;return [p[0]+(t[0]-p[0])*f,p[1]+(t[1]-p[1])*f];};
      const u=inset(q),v=inset(r),curve=Array.from({length:9},(_,m)=>{const t=m/8;return [(1-t)**2*u[0]+2*t*(1-t)*p[0]+t*t*v[0],(1-t)**2*u[1]+2*t*(1-t)*p[1]+t*t*v[1]];});
      const check=[smooth[smooth.length-1],...curve,r];
      if(check.slice(1).every((q2,m)=>clearSegment(check[m],q2)))smooth.push(...curve);else smooth.push(p);
    }
    smooth.push(pulled[pulled.length-1]);
    return smooth.slice(1).every((p,k)=>clearSegment(smooth[k],p))?smooth:null;
  }
  return {path,reachable,nearest:p=>{const i=cellOf(p);return i<0?null:centerOf(i);}};
}

export function createCrowd({seed=1,count=26}={}){
  // Free-roaming residents: spawn scattered over the whole road network, then
  // keep picking random reachable destinations. Paths come from the validated
  // grid, so nobody crosses buildings, the fountain, beds or lawns.
  // nearMesh: true while any cell within a cell radius is walkable — the
  // tolerance that keeps the escape safety net from fighting in-path motion.
  const nearMesh=(x,y)=>{
    const cx=Math.round(x/CELL),cy=Math.round(y/CELL);
    for(let dy=-1;dy<=1;dy++)for(let dx=-1;dx<=1;dx++){
      const nx=cx+dx,ny=cy+dy;
      if(nx>=0&&ny>=0&&nx<COLS&&ny<ROWS&&mesh()[ny*COLS+nx])return true;
    }
    return false;
  };
  const random=seededRandom(seed);
  const nav=createNavigation();
  const events={planned:0,notice:0};
  const pool=nav.reachable.slice();
  for(let i=pool.length-1;i>0;i--){const j=Math.floor(random()*(i+1));[pool[i],pool[j]]=[pool[j],pool[i]];}
  const spots=[];
  for(const minGap of [52,36,22,0]){
    spots.length=0;
    for(const pt of pool){
      if(spots.every(s=>distance(s,pt)>minGap))spots.push(pt);
      if(spots.length>=count)break;
    }
    if(spots.length>=count)break;
  }
  const noticeSpots=nav.reachable.filter(p=>distance(p,NOTICE)<=36);
  const people=Array.from({length:count},(_,id)=>{
    const pt=spots[id%spots.length]||[840,430];
    return {id,x:pt[0],y:pt[1],speed:8+random()*5,state:'pause',wait:.4+random()*2.8,path:[],index:0,goal:'wander',dx:random()<.5?-1:1,dy:0,gait:random()*7,held:false,age:0,stuck:0,lastX:pt[0],lastY:pt[1]};
  });
  const plan=p=>{
    for(let tries=0;tries<6;tries++){
      const read=noticeSpots.length>0&&random()<.09;
      const goal=read?noticeSpots[Math.floor(random()*noticeSpots.length)]:nav.reachable[Math.floor(random()*nav.reachable.length)];
      if(!read&&distance([p.x,p.y],goal)<130&&tries<5)continue;
      const path=nav.path([p.x,p.y],goal);
      if(path&&path.length>1){p.path=path;p.index=1;p.goal=read?'notice':'wander';p.state='walk';p.stuck=0;p.lastX=p.x;p.lastY=p.y;events.planned++;return;}
    }
    p.wait=.6+random()*1.2;
  };
  const move=(p,dt)=>{
    const target=p.path[p.index],d=distance([p.x,p.y],target),step=Math.min(d,p.speed*dt);
    if(d>0){p.dx=(target[0]-p.x)/d;p.dy=(target[1]-p.y)/d;p.x+=p.dx*step;p.y+=p.dy*step;p.gait+=step/10;}
    if(d<=step+.00001)p.index++;
    return p.index>=p.path.length;
  };
  function update(dt){if(dt<=0)return;for(const p of people){if(p.held)continue;p.age+=dt;
    // Safety net for genuine escapes only: continuous positions sit between
    // cell centers, so require a full cell of drift before pulling back.
    if(!nearMesh(p.x,p.y)){
      const home=nav.nearest([p.x,p.y]);
      if(home){const d=distance([p.x,p.y],home),step=Math.min(d,3*dt);p.x+=(home[0]-p.x)/d*step;p.y+=(home[1]-p.y)/d*step;p.gait+=step/10;p.dx=(home[0]-p.x)/d;}
      continue;
    }
    if(p.state==='walk'){
      const q=p.path[p.index];
      // Validate the next step before committing it; re-plan in place if a bad
      // point ever slips through, without teleporting.
      if(!q||!isNavigable(q[0],q[1])){p.state='pause';p.path=[];p.wait=.05;continue;}
      if(move(p,dt)){
        if(p.goal==='notice'){p.state='read-notice';p.wait=5+random()*4;p.dx=-1;events.notice++;}
        else{p.state='pause';p.wait=.8+random()*3.2;if(random()<.4)p.dx*=-1;}
        p.path=[];
        continue;
      }
      if(Math.hypot(p.x-p.lastX,p.y-p.lastY)<.05)p.stuck+=dt;else{p.stuck=0;p.lastX=p.x;p.lastY=p.y;}
      if(p.stuck>2.5){p.state='pause';p.path=[];p.wait=.1;p.stuck=0;}
      continue;
    }
    p.wait-=dt;if(p.wait>0)continue;
    if(p.state==='read-notice'){p.state='pause';p.wait=.4+random()*.8;continue;}
    plan(p);
  }}
  return {people,update,events,nav:{reachable:nav.reachable}};
}
